module.exports = __webpack_public_path__ + "img/myosotis.5c30a2e8.jpg";